export default "__VITE_ASSET__5d35dbc1__"